import useQueryParams from "~/components/build/Show/lib/useQueryParams";
import {
  DockPosition,
  useAdjustedDockPosition,
} from "~/components/build/Show/lib/useAdjustedDockPosition";

/**
 * A right- or centre-docked drawer occupies the main content area, the same
 * space the docked annotations panel would sit beside. Rather than render the
 * two together, the open drawer takes the whole area and the annotations panel
 * is hidden in favour of it. Returns true while that's the case.
 *
 * Bottom-docked (drawer stacks under the content, leaving room beside for the
 * panel) and the keyboard-style Full position are left out.
 *
 * Keyed off the *adjusted* dock position so the narrow-viewport fallback
 * (right → centre) is handled the same as an explicit centre dock.
 */
export function useDrawerReplacesAnnotations(): boolean {
  const { sid, jid, open } = useQueryParams();
  const adjustedDockPosition = useAdjustedDockPosition();

  const drawerOpen = Boolean(sid || jid) && open !== "false";
  return (
    drawerOpen &&
    (adjustedDockPosition === DockPosition.Right || adjustedDockPosition === DockPosition.Center)
  );
}
